/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'minimal' }, { id: 'quick' }, { id: 'invest' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-styling-effort"
      progress={51}
      field="hairstyleStylingEffort"
      setter="setHairstyleStylingEffort"
      ns="hairstyleStylingEffort"
      imageName="hairstyleStylingEffort"
      options={OPTIONS}
    />
  );
}

export default Page;
